import React, { useState } from "react";
import "./landing.css";
import BgVideo from "../../assets/bgvideo.mp4";

export default function HeroSection() {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="hero">
      {/* Background Video */}
      <video
        className="hero-background-video"
        autoPlay
        muted
        loop
        playsInline
        poster="/img/intro-bg.jpg"
      >
        <source src={BgVideo} type="video/mp4" />
        <source src="/videos/hero-background.webm" type="video/webm" />
        {/* Fallback for browsers that don't support video */}
      </video>
      
      {/* Video overlay for better text readability */}
      <div className="hero-overlay"></div>
      
      <div className="hero-content-section">
        <h1 className="hero-title">
          Know What's Coming. <br />Act Before It Hits.
        </h1>
        <p className="hero-subtext">
          Radar+ scans your stack, your market, and your weak spots — then handles risks and opportunities for you.
          <br/>
          No clutter. No noise. Just action where it counts.

        </p>
        {/* {showMore && (
          <p className="hero-subtext">
            RADAR+ continuously scans your internal systems and external shifts — then auto-generates actions to neutralize risks and capture opportunities before they impact your bottom line.
            No blind spots. No missed signals. Just faster, smarter, safer scaling — on autopilot.
          </p>
        )} */}
        <div className="hero-buttons">
          <button className="primary-btn">
            <span>Get Started</span>
          </button>
          {/* <button
            className="secondary-btn"
            onClick={() => setShowMore(!showMore)}
          >
            {showMore ? 'Show Less' : 'See how it works →'}
          </button> */}
        </div>
      </div>
    </div>
  );
}
